import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationBehaviorOptions, NavigationEnd, Router } from '@angular/router';
import { navPaths, Support } from '@core/models/support.model';
import { CampagneTypologieService, GlobalDataService } from '@core/services';
import { ProduitService } from '@core/services/produit.service';

@Component({
  selector: 'app-selection-lettre-enveloppe-card',
  templateUrl: './selection-lettre-enveloppe-card.component.html',
  styleUrls: ['./selection-lettre-enveloppe-card.component.scss']
})
export class SelectionLettreEnveloppeCardComponent implements OnInit {


  @Input() EditMode?: boolean = false;
  @Input() showFormat?: boolean = true;
  @Input() showDimension?: boolean = true;
  @Input() showGrammage?: boolean = true;
  @Input() showFinition?: boolean = true;
  @Input() showEncre?: boolean = true;

  support: Support = new Support();

  navigationSubscription;

  navigationOption: NavigationBehaviorOptions = { state: {} };

  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,
    public _GlobalDataService: GlobalDataService,
    private _ProduitService: ProduitService,
    private _CampagneTypologieService: CampagneTypologieService,

  ) {
    // subscribe to the router events. Store the subscription so we can
    // unsubscribe later.
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initialise();
      }
    });
  }

  initialise() {
    this.support.support = this._GlobalDataService.getLibelleProduit('CodeTypologie', this._GlobalDataService.Campagne.CodeTypologie, 'Typologie')
    this.support.dimension = this._GlobalDataService.getLibelleProduit('CodeDimensionsSupport', this._GlobalDataService.Campagne.CodeDimensionsSupport, 'DimensionsSupport')
    this.support.grammage = this._GlobalDataService.getLibelleProduit('CodeGrammageSupport', this._GlobalDataService.Campagne.CodeGrammageSupport, 'GrammageSupport')
    this.support.finition = this._GlobalDataService.getLibelleProduit('CodeFinitionSupport', this._GlobalDataService.Campagne.CodeFinitionSupport, 'FinitionSupport')
    this.support.Encre = this._GlobalDataService.getLibelleProduit('CodeEncreSupport', this._GlobalDataService.Campagne.CodeEncreSupport, 'EncreSupport');
  }


  ngOnInit(): void {
    this.initialise();
  }

  changeFormat(): void {
    console.log('changeFormat');
    this._CampagneTypologieService.navigate(navPaths.format, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }
  
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

}
